import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"

import ClientListItem from "./ClientListItem"
import ClientListLoader from "./ClientListLoader"
import useCoachingGroups from "./hooks/useCoachingGroups"
import useMobile from "../../hooks/useMobile"
import { useCoachingGroupsQuery } from "../../networking/coachingGroups/queries"
import useMobileViewStore, {
  SendBirdView,
} from "../home/store/useMobileViewStore"

const ClientList = () => {
  const { view } = useMobileViewStore()
  const isMobile = useMobile()

  const { upcomingSessionChannels, remainingChannels } = useCoachingGroups()
  const { isLoading: isLoadingCoachingGroups } = useCoachingGroupsQuery()

  if (isMobile && view !== SendBirdView.CHANNEL_LIST) return null
  if (isLoadingCoachingGroups) return <ClientListLoader />

  return (
    <div className="flex-col w-full">
      <div className="flex-col">
        <div className="py-4 px-3 w-full border-b border-borderPrimary">
          <Typography variant="bodySmallBold">
            Upcoming Session
            {upcomingSessionChannels?.length === 1 ? "" : "s"}
          </Typography>
        </div>
        {upcomingSessionChannels?.map(({ coachingGroup, upcomingSession }) => {
          return (
            <ClientListItem
              key={coachingGroup.id}
              coachingGroup={coachingGroup}
              isUpcomingSession={true}
              nextSession={upcomingSession}
            />
          )
        })}
      </div>
      <FlexBox direction="column" wrap={false}>
        <Typography
          variant="bodySmallBold"
          style={{
            width: "100%",
            padding: `${SPACING.space3} ${SPACING.space4}`,
            borderBottom: `1px solid ${JoonUIColor.border.default}`,
          }}
        >
          Other clients
        </Typography>
        {remainingChannels?.map(({ coachingGroup }) => {
          return (
            <ClientListItem
              key={coachingGroup.id}
              coachingGroup={coachingGroup}
            />
          )
        })}
      </FlexBox>
    </div>
  )
}

export default ClientList
